import { exceptionMessage1cx0ho62128p8 as exceptionMessage } from '../views/ElementContext.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../views/NativeElement.mjs';
import {
  h12aidul0n4qlwh as h1,
  text189ciz0cnr32o as text,
  subtext2yjmf1ok7kb40 as subtext,
} from '../views/direct/shortcuts.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../views/direct/Space.commonHtml.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../views/helpers.mjs';
import {
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
} from '../models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../views/direct/Button.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../views/direct/Button.mjs';
import {
  dialog3sxbjr735jrum as dialog,
  toast4hp3bb4ymp24 as toast,
} from '../views/l2/popoverHelpers.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../models/data.commonHtml.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../views/direct/modifiers.mjs';
import { stackTraceToString2670q6lbhdojj as stackTraceToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  reversed22y3au42jl32b as reversed,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../reactive/AppState.js.mjs';
import { Dimension__compareTo_impl_gsceod30y54irsnvl8x as Dimension__compareTo_impl_gsceod } from '../models/data.mjs';
import {
  Action2nhdpxpznfsbd as Action,
  Action18dong6ke5uus as Action_0,
} from '../reactive/Action.mjs';
import { Companion_instance1lm8x0jadqh2g as Companion_instance } from '../Platform.mjs';
import {
  get_probablyAppleUser3bj8owedvq6si as get_probablyAppleUser,
  get_isDevelopment16qk6tv1fuxkk as get_isDevelopment,
} from '../Platform.js.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { get_appName2d6x7t0626kwl as get_appName } from '../views/metadata.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { System_instance34rnn1q53nv02 as System_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import {
  RenderSize_Full_getInstance276lrvq07dtkk as RenderSize_Full_getInstance,
  renderToStringprxvmjepz2st as renderToString,
} from '../locale/LocalTimeRender.mjs';
import { Companion_getInstance13ujfby7pfhe7 as Companion_getInstance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { DriverSnapshotOptions27dyx43p9jzht as DriverSnapshotOptions } from '../views/Element.mjs';
import { generateSequence118suk3hffuuw as generateSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import {
  mapsbvh18eqox7a as map,
  toListx6x8nvfmvvht as toList,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  ElementWithAction109xd6kw8dlp as ElementWithAction,
  ElementWithSecondaryAction1gtvxto5sv58k as ElementWithSecondaryAction,
} from '../views/InteractiveElement.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  setClipboardTextsmriix4g698x as setClipboardText,
  download3e9i5zj8k9dp8 as download,
} from '../ExternalServices.mjs';
import { toBlob3efqyqa0phgb9 as toBlob } from '../fetch.js.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { sortWith4fnm6b3vw03s as sortWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_handlerComparator() {
  _init_properties_handling_kt__tkaie3();
  return handlerComparator;
}
var handlerComparator;
function get_messageComparator() {
  _init_properties_handling_kt__tkaie3();
  return messageComparator;
}
var messageComparator;
function ExceptionHandler$Companion$messageDialog$lambda($this$ExceptionHandler, exception, meta) {
  var tmp0_elvis_lhs = exceptionMessage($this$ExceptionHandler, exception, meta);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var message = tmp;
  dialog($this$ExceptionHandler, VOID, ($this$dialog, close) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())($this$dialog.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$dialog.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    h1(element, message.title_1);
    text(element, message.body_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (Space())(element.get_context_h02k06_k$(), 0.5);
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element.willAddChild_hz2iwc_k$(element_1);
    element_1.set_vertical_nuap32_k$(false);
    var _iterator__ex2g4s = message.actions_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var action = _iterator__ex2g4s.next_20eer_k$();
      // Inline function 'com.lightningkite.kiteui.views.important' call
      var this_0 = get_centered(element_1);
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      var this_1 = themed(this_0, ImportantSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_2 = themed(this_1, ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (Button())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      this_2.willAddChild_hz2iwc_k$(element_2);
      text(element_2, action.get_title_iz32un_k$());
      element_2.set_action_2ds022_k$(action);
      element_2.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_2);
    }
    // Inline function 'com.lightningkite.kiteui.views.card' call
    var this_3 = get_centered(element_1);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_4 = themed(this_3, CardSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_5 = themed(this_4, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (Button())(this_5.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_5.willAddChild_hz2iwc_k$(element_3);
    text(element_3, 'Close');
    onClick(element_3, VOID, VOID, VOID, ExceptionHandler$Companion$messageDialog$lambda$lambda$slambda(close));
    element_3.onStartup_vrxh3i_k$();
    this_5.addChild_2qpft2_k$(element_3);
    element_1.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_1);
    element.onStartup_vrxh3i_k$();
    $this$dialog.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
  return ExceptionHandler$Companion$messageDialog$lambda$lambda;
}
function ExceptionHandler$Companion$messageDialog$lambda$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function ExceptionHandler$Companion$messageDialog$lambda$lambda() {
  return Unit_instance;
}
function ExceptionHandler$Companion$stacktraceDialog$lambda($this$ExceptionHandler, exception, meta) {
  var tmp0_elvis_lhs = exceptionMessage($this$ExceptionHandler, exception, meta);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var message = tmp;
  dialog($this$ExceptionHandler, VOID, ($this$dialog, close) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())($this$dialog.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$dialog.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    h1(element, message.title_1);
    text(element, message.body_1);
    subtext(get_scrolling(sizeConstraints(element, VOID, VOID, VOID, get_rem(15))), stackTraceToString(exception));
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (Space())(element.get_context_h02k06_k$(), 0.5);
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element.willAddChild_hz2iwc_k$(element_1);
    element_1.set_vertical_nuap32_k$(false);
    var _iterator__ex2g4s = message.actions_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var action = _iterator__ex2g4s.next_20eer_k$();
      // Inline function 'com.lightningkite.kiteui.views.important' call
      var this_0 = get_centered(element_1);
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      var this_1 = themed(this_0, ImportantSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_2 = themed(this_1, ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (Button())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      this_2.willAddChild_hz2iwc_k$(element_2);
      text(element_2, action.get_title_iz32un_k$());
      element_2.set_action_2ds022_k$(action);
      element_2.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_2);
    }
    // Inline function 'com.lightningkite.kiteui.views.card' call
    var this_3 = get_centered(element_1);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_4 = themed(this_3, CardSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_5 = themed(this_4, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (Button())(this_5.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_5.willAddChild_hz2iwc_k$(element_3);
    text(element_3, 'Close');
    onClick(element_3, VOID, VOID, VOID, ExceptionHandler$Companion$stacktraceDialog$lambda$lambda$slambda(close));
    element_3.onStartup_vrxh3i_k$();
    this_5.addChild_2qpft2_k$(element_3);
    element_1.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_1);
    element.onStartup_vrxh3i_k$();
    $this$dialog.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
  return ExceptionHandler$Companion$stacktraceDialog$lambda$lambda;
}
function ExceptionHandler$Companion$stacktraceDialog$lambda$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function ExceptionHandler$Companion$stacktraceDialog$lambda$lambda() {
  return Unit_instance;
}
var MetadataClass;
function Metadata() {
  if (MetadataClass === VOID) {
    class $ {
      constructor(source, process, foregroundProcess, context) {
        context = context === VOID ? emptyMap() : context;
        this.source_1 = source;
        this.process_1 = process;
        this.foregroundProcess_1 = foregroundProcess;
        this.context_1 = context;
      }
      toString() {
        return 'Metadata(source=' + toString(this.source_1) + ', process=' + toString(this.process_1) + ', foregroundProcess=' + this.foregroundProcess_1 + ', context=' + toString_0(this.context_1) + ')';
      }
      hashCode() {
        var result = this.source_1 == null ? 0 : hashCode(this.source_1);
        result = imul(result, 31) + (this.process_1 == null ? 0 : hashCode(this.process_1)) | 0;
        result = imul(result, 31) + (this.foregroundProcess_1 == null ? 0 : getBooleanHashCode(this.foregroundProcess_1)) | 0;
        result = imul(result, 31) + hashCode(this.context_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Metadata()))
          return false;
        if (!equals(this.source_1, other.source_1))
          return false;
        if (!equals(this.process_1, other.process_1))
          return false;
        if (!(this.foregroundProcess_1 == other.foregroundProcess_1))
          return false;
        if (!equals(this.context_1, other.context_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Metadata');
    MetadataClass = $;
  }
  return MetadataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        tmp.messageDialog_1 = ExceptionHandler_0(0.0, ExceptionHandler$Companion$messageDialog$lambda);
        var tmp_0 = this;
        tmp_0.stacktraceDialog_1 = ExceptionHandler_0(0.0, ExceptionHandler$Companion$stacktraceDialog$lambda);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
function get_forSpecificException() {
  return false;
}
var ExceptionHandlerClass;
function ExceptionHandler() {
  if (ExceptionHandlerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ExceptionHandler');
    ExceptionHandlerClass = $;
  }
  return ExceptionHandlerClass;
}
var ExceptionToMessage$Companion$plainTextException$$inlined$ExceptionToMessage$1Class;
function ExceptionToMessage$Companion$plainTextException$$inlined$ExceptionToMessage$1() {
  if (ExceptionToMessage$Companion$plainTextException$$inlined$ExceptionToMessage$1Class === VOID) {
    class $ {
      constructor($priority) {
        this.priority_1 = $priority;
        this.forSpecificException_1 = true;
      }
      get_priority_jyafsd_k$() {
        return this.priority_1;
      }
      get_forSpecificException_cnbvel_k$() {
        return this.forSpecificException_1;
      }
      message_rracq9_k$(context, exception, metadata) {
        if (!(exception instanceof PlainTextException()))
          return null;
        return new (ExceptionMessage())(exception.title_1, exception.get_message_h23axq_k$(), exception.actions_1);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [ExceptionToMessage()]);
    ExceptionToMessage$Companion$plainTextException$$inlined$ExceptionToMessage$1Class = $;
  }
  return ExceptionToMessage$Companion$plainTextException$$inlined$ExceptionToMessage$1Class;
}
function ExceptionToMessage$Companion$unexpectedError$lambda($this$ExceptionToMessage, it) {
  return new (ExceptionMessage())('Error', 'An unexpected error occurred.');
}
function ExceptionToMessage$Companion$debugInformation$lambda($this$ExceptionToMessage, e, meta) {
  var usingStacktraceDialog = $this$ExceptionToMessage.exceptionHandlers_1.contains_oe3u0r_k$(Companion_getInstance_0().stacktraceDialog_1);
  var tmp = 'Error: ' + e.toString();
  var tmp_0 = e.message;
  var tmp0_safe_receiver = e.cause;
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = 'Caused By: ' + tmp0_safe_receiver.toString();
  }
  var tmp_2 = joinToString(listOfNotNull([tmp_0, tmp_1, usingStacktraceDialog ? null : 'Stacktrace: ' + stackTraceToString(e)]), '\n');
  var tmp_3;
  if (get_probablyAppleUser(Companion_instance)) {
    tmp_3 = null;
  } else {
    var tmp_4 = Dimension__compareTo_impl_gsceod(AppState_getInstance().get_windowInfo_amgsav_k$().get_value_j01efc_k$().width_1, get_rem(40)) >= 0 ? 'Copy to Clipboard' : 'Copy';
    tmp_3 = Action(tmp_4, VOID, VOID, VOID, VOID, VOID, ExceptionToMessage$Companion$debugInformation$lambda$slambda($this$ExceptionToMessage, meta, e));
  }
  var tmp_5 = tmp_3;
  return new (ExceptionMessage())(tmp, tmp_2, listOfNotNull([tmp_5, Action('Export', VOID, VOID, VOID, VOID, VOID, ExceptionToMessage$Companion$debugInformation$lambda$slambda_0($this$ExceptionToMessage, meta, e))]));
}
function ExceptionToMessage$Companion$debugInformation$lambda$report$lambda(it) {
  return it.get_parent_hy4reb_k$();
}
function invoke$report($this_ExceptionToMessage, $meta, $e) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  var tmp0_safe_receiver = get_appName($this_ExceptionToMessage);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = '# Error Report for ' + tmp0_safe_receiver;
  }
  var tmp1_elvis_lhs = tmp;
  // Inline function 'kotlin.text.appendLine' call
  var value = tmp1_elvis_lhs == null ? '# Error Report' : tmp1_elvis_lhs;
  // Inline function 'kotlin.text.appendLine' call
  this_0.append_22ad7x_k$(value).append_58al37_k$(_Char___init__impl__6a9atx(10));
  // Inline function 'kotlin.text.appendLine' call
  this_0.append_58al37_k$(_Char___init__impl__6a9atx(10));
  // Inline function 'kotlin.text.appendLine' call
  var value_0 = '## Metadata';
  // Inline function 'kotlin.text.appendLine' call
  this_0.append_22ad7x_k$(value_0).append_58al37_k$(_Char___init__impl__6a9atx(10));
  // Inline function 'kotlin.text.appendLine' call
  var value_1 = '- __Timestamp__: ' + renderToString(System_instance.now_2cba_k$(), RenderSize_Full_getInstance()) + ' ' + Companion_getInstance().currentSystemDefault_9rduv_k$().toString();
  // Inline function 'kotlin.text.appendLine' call
  this_0.append_22ad7x_k$(value_1).append_58al37_k$(_Char___init__impl__6a9atx(10));
  var tmp3_safe_receiver = $meta == null ? null : $meta.source_1;
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var options = new (DriverSnapshotOptions())(VOID, VOID, false, false);
    var tmp_0 = generateSequence(tmp3_safe_receiver, ExceptionToMessage$Companion$debugInformation$lambda$report$lambda);
    var path = joinToString(reversed(toList(map(tmp_0, (it) => it.driverDisplay_abwxi1_k$(options)))), '/');
    var display = tmp3_safe_receiver.driverDisplay_abwxi1_k$(new (DriverSnapshotOptions())(VOID, VOID, false, false));
    // Inline function 'kotlin.text.appendLine' call
    var value_2 = '- __Source Element__: ' + tmp3_safe_receiver.toString() + ' (' + display + ') @ ' + path;
    // Inline function 'kotlin.text.appendLine' call
    this_0.append_22ad7x_k$(value_2).append_58al37_k$(_Char___init__impl__6a9atx(10));
  }
  var tmp5_safe_receiver = $meta == null ? null : $meta.process_1;
  if (tmp5_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp_1;
    if (isInterface(tmp5_safe_receiver, Action_0())) {
      var tmp_2;
      var tmp_3 = $meta.source_1;
      var tmp0_safe_receiver_0 = (!(tmp_3 == null) ? isInterface(tmp_3, ElementWithAction()) : false) ? tmp_3 : null;
      if (tmp5_safe_receiver === (tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.get_action_avldmn_k$())) {
        tmp_2 = tmp5_safe_receiver.get_title_iz32un_k$() + ' [action]';
      } else {
        var tmp_4 = $meta.source_1;
        var tmp1_safe_receiver = (!(tmp_4 == null) ? isInterface(tmp_4, ElementWithSecondaryAction()) : false) ? tmp_4 : null;
        if (tmp5_safe_receiver === (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_secondaryAction_6iem8v_k$())) {
          tmp_2 = tmp5_safe_receiver.get_title_iz32un_k$() + ' [secondaryAction]';
        } else {
          tmp_2 = tmp5_safe_receiver.get_title_iz32un_k$();
        }
      }
      tmp_1 = tmp_2;
    } else {
      var tmp_5 = toString_0(tmp5_safe_receiver);
      var tmp2_elvis_lhs = getKClassFromExpression(tmp5_safe_receiver).get_simpleName_r6f8py_k$();
      tmp_1 = tmp_5 + ' (' + (tmp2_elvis_lhs == null ? 'anonymous' : tmp2_elvis_lhs) + ')';
    }
    var process = tmp_1;
    this_0.append_22ad7x_k$('- __Process__: ' + process);
    var tmp3_safe_receiver_0 = $meta.foregroundProcess_1;
    if (tmp3_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp3_safe_receiver_0 ? this_0.append_22ad7x_k$(' (Foreground Process)') : this_0.append_22ad7x_k$(' (Background Process)');
    }
    // Inline function 'kotlin.text.appendLine' call
    this_0.append_58al37_k$(_Char___init__impl__6a9atx(10));
  }
  var tmp7_safe_receiver = $meta == null ? null : $meta.context_1;
  var tmp_6;
  if (tmp7_safe_receiver == null) {
    tmp_6 = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_7;
    if (!tmp7_safe_receiver.isEmpty_y1axqb_k$()) {
      tmp_7 = tmp7_safe_receiver;
    } else {
      tmp_7 = null;
    }
    tmp_6 = tmp_7;
  }
  var tmp8_safe_receiver = tmp_6;
  if (tmp8_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.text.appendLine' call
    var value_3 = '- __Context__: ' + toString_0(tmp8_safe_receiver);
    // Inline function 'kotlin.text.appendLine' call
    this_0.append_22ad7x_k$(value_3).append_58al37_k$(_Char___init__impl__6a9atx(10));
  }
  // Inline function 'kotlin.text.appendLine' call
  this_0.append_58al37_k$(_Char___init__impl__6a9atx(10));
  // Inline function 'kotlin.text.appendLine' call
  var value_4 = '## Summary';
  // Inline function 'kotlin.text.appendLine' call
  this_0.append_22ad7x_k$(value_4).append_58al37_k$(_Char___init__impl__6a9atx(10));
  // Inline function 'kotlin.text.appendLine' call
  var value_5 = '- __Error__: ' + $e.toString();
  // Inline function 'kotlin.text.appendLine' call
  this_0.append_22ad7x_k$(value_5).append_58al37_k$(_Char___init__impl__6a9atx(10));
  var tmp9_safe_receiver = $e.cause;
  if (tmp9_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.text.appendLine' call
    var value_6 = '- __Caused By__: ' + tmp9_safe_receiver.toString();
    // Inline function 'kotlin.text.appendLine' call
    this_0.append_22ad7x_k$(value_6).append_58al37_k$(_Char___init__impl__6a9atx(10));
  }
  // Inline function 'kotlin.text.appendLine' call
  this_0.append_58al37_k$(_Char___init__impl__6a9atx(10));
  // Inline function 'kotlin.text.appendLine' call
  var value_7 = '__Stacktrace__';
  // Inline function 'kotlin.text.appendLine' call
  this_0.append_22ad7x_k$(value_7).append_58al37_k$(_Char___init__impl__6a9atx(10));
  // Inline function 'kotlin.text.appendLine' call
  // Inline function 'kotlin.text.appendLine' call
  this_0.append_22ad7x_k$('```').append_58al37_k$(_Char___init__impl__6a9atx(10));
  // Inline function 'kotlin.text.appendLine' call
  var value_8 = stackTraceToString($e);
  // Inline function 'kotlin.text.appendLine' call
  this_0.append_22ad7x_k$(value_8).append_58al37_k$(_Char___init__impl__6a9atx(10));
  // Inline function 'kotlin.text.appendLine' call
  // Inline function 'kotlin.text.appendLine' call
  this_0.append_22ad7x_k$('```').append_58al37_k$(_Char___init__impl__6a9atx(10));
  return this_0.toString();
}
function ExceptionToMessage$Companion$debugInformation$lambda$slambda($this_ExceptionToMessage, $meta, $e) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    setClipboardText($this_ExceptionToMessage, invoke$report($this_ExceptionToMessage, $meta, $e));
    toast($this_ExceptionToMessage, 'Copied to Clipboard!');
    return Unit_instance;
  }), 1);
}
function ExceptionToMessage$Companion$debugInformation$lambda$slambda_0($this_ExceptionToMessage, $meta, $e) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    yield* download($this_ExceptionToMessage, 'error_export.md', toBlob(invoke$report($this_ExceptionToMessage, $meta, $e)), VOID, $completion);
    return Unit_instance;
  }), 1);
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        // Inline function 'com.lightningkite.kiteui.exceptions.ExceptionToMessage' call
        tmp.plainTextException_1 = new (ExceptionToMessage$Companion$plainTextException$$inlined$ExceptionToMessage$1())(0.0);
        var tmp_0 = this;
        tmp_0.unexpectedError_1 = ExceptionToMessage_0(0.0, ExceptionToMessage$Companion$unexpectedError$lambda);
        var tmp_1 = this;
        tmp_1.debugInformation_1 = ExceptionToMessage_1(0.0, ExceptionToMessage$Companion$debugInformation$lambda);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new (Companion_0())();
  return Companion_instance_1;
}
function get_forSpecificException_0() {
  return false;
}
var ExceptionToMessageClass;
function ExceptionToMessage() {
  if (ExceptionToMessageClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ExceptionToMessage');
    ExceptionToMessageClass = $;
  }
  return ExceptionToMessageClass;
}
function ExceptionHandler_0(priority, handler) {
  priority = priority === VOID ? 0.5 : priority;
  _init_properties_handling_kt__tkaie3();
  return new (ExceptionHandler$1())(priority, handler);
}
var ExceptionMessageClass;
function ExceptionMessage() {
  if (ExceptionMessageClass === VOID) {
    class $ {
      constructor(title, body, actions) {
        actions = actions === VOID ? emptyList() : actions;
        this.title_1 = title;
        this.body_1 = body;
        this.actions_1 = actions;
      }
      toString() {
        return 'ExceptionMessage(title=' + this.title_1 + ', body=' + this.body_1 + ', actions=' + toString_0(this.actions_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.title_1);
        result = imul(result, 31) + getStringHashCode(this.body_1) | 0;
        result = imul(result, 31) + hashCode(this.actions_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ExceptionMessage()))
          return false;
        if (!(this.title_1 === other.title_1))
          return false;
        if (!(this.body_1 === other.body_1))
          return false;
        if (!equals(this.actions_1, other.actions_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ExceptionMessage');
    ExceptionMessageClass = $;
  }
  return ExceptionMessageClass;
}
var PlainTextExceptionClass;
function PlainTextException() {
  if (PlainTextExceptionClass === VOID) {
    class $ extends Exception() {
      constructor(message, title, actions) {
        return new.target.new_com_lightningkite_kiteui_exceptions_PlainTextException_r8qaq2_k$(message, title, actions);
      }
      static new_com_lightningkite_kiteui_exceptions_PlainTextException_r8qaq2_k$(message, title, actions) {
        title = title === VOID ? 'Error' : title;
        actions = actions === VOID ? emptyList() : actions;
        var $this = this.new_kotlin_Exception_hsqbop_k$(message);
        captureStack($this, $this.$throwableCtor_2);
        $this.message_1 = message;
        $this.title_1 = title;
        $this.actions_1 = actions;
        delete $this.message;
        return $this;
      }
      get_message_h23axq_k$() {
        return this.message_1;
      }
      get message() {
        return this.get_message_h23axq_k$();
      }
    }
    initMetadataForClass($, 'PlainTextException');
    PlainTextExceptionClass = $;
  }
  return PlainTextExceptionClass;
}
function ExceptionToMessage_0(priority, message) {
  priority = priority === VOID ? 0.5 : priority;
  _init_properties_handling_kt__tkaie3();
  return new (ExceptionToMessage$1())(priority, message);
}
function ExceptionToMessage_1(priority, message) {
  priority = priority === VOID ? 0.5 : priority;
  _init_properties_handling_kt__tkaie3();
  return new (ExceptionToMessage$2())(priority, message);
}
var ExceptionHandlersTreeClass;
function ExceptionHandlersTree() {
  if (ExceptionHandlersTreeClass === VOID) {
    class $ {
      constructor(parent) {
        parent = parent === VOID ? null : parent;
        this.parent_1 = parent;
        this.handlers_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.messages_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      add_yo2zg7_k$(handler) {
        this.handlers_1.add_utx5q5_k$(handler);
        sortWith(this.handlers_1, get_handlerComparator());
      }
      add_xq6d8r_k$(message) {
        this.messages_1.add_utx5q5_k$(message);
        sortWith(this.messages_1, get_messageComparator());
      }
      plusAssign_4ugdj3_k$(handler) {
        return this.add_yo2zg7_k$(handler);
      }
      plusAssign_2usnwd_k$(message) {
        return this.add_xq6d8r_k$(message);
      }
      handle_wdrjsg_k$(context, exception, metadata) {
        var tmp0 = this.handlers_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            var result = element.handle_wdrjsg_k$(context, exception, metadata);
            if (!(result == null)) {
              tmp$ret$0 = result;
              break $l$block;
            }
          }
          tmp$ret$0 = null;
        }
        var tmp0_elvis_lhs = tmp$ret$0;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = this.parent_1;
          tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.handle_wdrjsg_k$(context, exception, metadata);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      message_rracq9_k$(context, exception, metadata) {
        var tmp0 = this.messages_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            var result = element.message_rracq9_k$(context, exception, metadata);
            if (!(result == null)) {
              tmp$ret$0 = result;
              break $l$block;
            }
          }
          tmp$ret$0 = null;
        }
        var tmp0_elvis_lhs = tmp$ret$0;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = this.parent_1;
          tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.message_rracq9_k$(context, exception, metadata);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      contains_oe3u0r_k$(handler) {
        var tmp;
        if (this.handlers_1.contains_aljjnj_k$(handler)) {
          tmp = true;
        } else {
          var tmp0_safe_receiver = this.parent_1;
          tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.contains_oe3u0r_k$(handler)) === true;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'ExceptionHandlersTree', ExceptionHandlersTree);
    ExceptionHandlersTreeClass = $;
  }
  return ExceptionHandlersTreeClass;
}
function installSmartHandlers(_this__u8e3s4) {
  _init_properties_handling_kt__tkaie3();
  if (get_isDevelopment(Companion_instance)) {
    installDebugHandlers(_this__u8e3s4);
  } else {
    installStandardHandlers(_this__u8e3s4);
  }
}
function installDebugHandlers(_this__u8e3s4) {
  _init_properties_handling_kt__tkaie3();
  _this__u8e3s4.add_yo2zg7_k$(Companion_getInstance_0().stacktraceDialog_1);
  _this__u8e3s4.add_xq6d8r_k$(Companion_getInstance_1().plainTextException_1);
  _this__u8e3s4.add_xq6d8r_k$(Companion_getInstance_1().debugInformation_1);
}
function installStandardHandlers(_this__u8e3s4) {
  _init_properties_handling_kt__tkaie3();
  _this__u8e3s4.add_yo2zg7_k$(Companion_getInstance_0().messageDialog_1);
  _this__u8e3s4.add_xq6d8r_k$(Companion_getInstance_1().plainTextException_1);
  _this__u8e3s4.add_xq6d8r_k$(Companion_getInstance_1().unexpectedError_1);
}
function ExceptionHandler_1(priority, handler) {
  priority = priority === VOID ? 0.5 : priority;
  _init_properties_handling_kt__tkaie3();
  return new (ExceptionHandler$2())(priority, handler);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
var sam$kotlin_Comparator$0Class_0;
function sam$kotlin_Comparator$0_0() {
  if (sam$kotlin_Comparator$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_0 = $;
  }
  return sam$kotlin_Comparator$0Class_0;
}
function handlerComparator$lambda(a, b) {
  _init_properties_handling_kt__tkaie3();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.get_forSpecificException_cnbvel_k$();
  var tmp$ret$2 = a.get_forSpecificException_cnbvel_k$();
  return compareValues(tmp, tmp$ret$2);
}
function messageComparator$lambda(a, b) {
  _init_properties_handling_kt__tkaie3();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.get_forSpecificException_cnbvel_k$();
  var tmp$ret$2 = a.get_forSpecificException_cnbvel_k$();
  return compareValues(tmp, tmp$ret$2);
}
var ExceptionHandler$1Class;
function ExceptionHandler$1() {
  if (ExceptionHandler$1Class === VOID) {
    class $ {
      constructor($priority, $handler) {
        this.$handler_1 = $handler;
        this.priority_1 = $priority;
        this.forSpecificException_1 = false;
      }
      get_priority_jyafsd_k$() {
        return this.priority_1;
      }
      get_forSpecificException_cnbvel_k$() {
        return this.forSpecificException_1;
      }
      handle_wdrjsg_k$(context, exception, metadata) {
        return this.$handler_1(context, exception, metadata);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [ExceptionHandler()]);
    ExceptionHandler$1Class = $;
  }
  return ExceptionHandler$1Class;
}
var ExceptionToMessage$1Class;
function ExceptionToMessage$1() {
  if (ExceptionToMessage$1Class === VOID) {
    class $ {
      constructor($priority, $message) {
        this.$message_1 = $message;
        this.priority_1 = $priority;
        this.forSpecificException_1 = false;
      }
      get_priority_jyafsd_k$() {
        return this.priority_1;
      }
      get_forSpecificException_cnbvel_k$() {
        return this.forSpecificException_1;
      }
      message_rracq9_k$(context, exception, metadata) {
        return this.$message_1(context, exception);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [ExceptionToMessage()]);
    ExceptionToMessage$1Class = $;
  }
  return ExceptionToMessage$1Class;
}
var ExceptionToMessage$2Class;
function ExceptionToMessage$2() {
  if (ExceptionToMessage$2Class === VOID) {
    class $ {
      constructor($priority, $message) {
        this.$message_1 = $message;
        this.priority_1 = $priority;
        this.forSpecificException_1 = false;
      }
      get_priority_jyafsd_k$() {
        return this.priority_1;
      }
      get_forSpecificException_cnbvel_k$() {
        return this.forSpecificException_1;
      }
      message_rracq9_k$(context, exception, metadata) {
        return this.$message_1(context, exception, metadata);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [ExceptionToMessage()]);
    ExceptionToMessage$2Class = $;
  }
  return ExceptionToMessage$2Class;
}
var ExceptionHandler$2Class;
function ExceptionHandler$2() {
  if (ExceptionHandler$2Class === VOID) {
    class $ {
      constructor($priority, $handler) {
        this.$handler_1 = $handler;
        this.priority_1 = $priority;
        this.forSpecificException_1 = false;
      }
      get_priority_jyafsd_k$() {
        return this.priority_1;
      }
      get_forSpecificException_cnbvel_k$() {
        return this.forSpecificException_1;
      }
      handle_wdrjsg_k$(context, exception, metadata) {
        return this.$handler_1(context, exception);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [ExceptionHandler()]);
    ExceptionHandler$2Class = $;
  }
  return ExceptionHandler$2Class;
}
var properties_initialized_handling_kt_4wcli1;
function _init_properties_handling_kt__tkaie3() {
  if (!properties_initialized_handling_kt_4wcli1) {
    properties_initialized_handling_kt_4wcli1 = true;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = handlerComparator$lambda;
    // Inline function 'kotlin.comparisons.thenByDescending' call
    var this_0 = new (sam$kotlin_Comparator$0())(tmp);
    var tmp_0 = (a, b) => {
      var previousCompare = this_0.compare(a, b);
      var tmp;
      if (!(previousCompare === 0)) {
        tmp = previousCompare;
      } else {
        // Inline function 'kotlin.comparisons.compareValuesBy' call
        var tmp_0 = b.get_priority_jyafsd_k$();
        var tmp$ret$4 = a.get_priority_jyafsd_k$();
        tmp = compareValues(tmp_0, tmp$ret$4);
      }
      return tmp;
    };
    handlerComparator = new (sam$kotlin_Comparator$0())(tmp_0);
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_1 = messageComparator$lambda;
    // Inline function 'kotlin.comparisons.thenByDescending' call
    var this_1 = new (sam$kotlin_Comparator$0_0())(tmp_1);
    var tmp_2 = (a, b) => {
      var previousCompare = this_1.compare(a, b);
      var tmp;
      if (!(previousCompare === 0)) {
        tmp = previousCompare;
      } else {
        // Inline function 'kotlin.comparisons.compareValuesBy' call
        var tmp_0 = b.get_priority_jyafsd_k$();
        var tmp$ret$4 = a.get_priority_jyafsd_k$();
        tmp = compareValues(tmp_0, tmp$ret$4);
      }
      return tmp;
    };
    messageComparator = new (sam$kotlin_Comparator$0_0())(tmp_2);
  }
}
//region block: exports
export {
  Metadata as Metadata2mqfolh2et60e,
  ExceptionHandlersTree as ExceptionHandlersTree3d2va1xldjhw8,
  ExceptionHandler_0 as ExceptionHandler6hcmz9gcndpu,
  ExceptionHandler_1 as ExceptionHandler3ohep65iljyrj,
  ExceptionMessage as ExceptionMessage21t2b5aa8xtox,
  ExceptionToMessage as ExceptionToMessage30hyfnqwmqxl4,
  PlainTextException as PlainTextException3c81a0qh9m2e2,
  installSmartHandlers as installSmartHandlersfwcvh69h3js4,
};
//endregion

//# sourceMappingURL=handling.mjs.map
